// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__iUUTj","rootCenter":"LoadMoreObserver_rootCenter__10U-L","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__10Bdp"};